import React from 'react'
import './MobanItem.css'
import PropTypes from 'prop-types';
import video_play from '../imageSrc/video_play.png';
import randomfile from '../imageSrc/randomfile.png';
import checkfile from '../imageSrc/checkfile.png';
import {fetchGet} from "../utils/fetchData";
import TextareaAutosize from 'react-autosize-textarea';

class MobanItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            textareaValue: this.props.data.module_body,
            inputValue: '',
            flag: false,

        };
    }

    handleValueChange = (e) => {
        // let lineHeight = 20;
        // let height = parseInt(getComputedStyle(e.target).height.slice(0, -2), 10);
        // if (e.target.scrollHeight > height) {
        //     e.target.style.height = `${e.target.scrollHeight}px`;
        // } else {
        //     while (height >= e.target.scrollHeight) {
        //         e.target.style.height = `${height - lineHeight}px`;
        //         height -= lineHeight;
        //     }
        //     e.target.style.height = `${height + lineHeight}px`;
        // }
        console.log(e.target.value);
        this.setState({
            textareaValue: e.target.value,
        });
    };

    handleTitleChange = (e) => {
        this.setState({
            inputValue: e.target.value,
        })
    }

    handleItemClick = (video) => {
        console.log(video);
        this.props.playVideo(video);
    }

    handleRandomClick = (data) => {
        console.log(data.modules);
        let params = {modules:data.modules};
        fetchGet('paragraph',params,null)
            .then(data => {
                if (data.code === 200) {
                    this.setState({
                        textareaValue: data.data.info,
                    });

                }

            });
    }

    handleClick = (index, e) => {
        console.log(e.target);
        // e.nativeEvent.stopImmediatePropagation();
        this.props.itemClick(index);
    }

    detectionClick = () => {
        console.log('detect');
    }

    render(){
        return(
            <div onClick={this.handleClick.bind(this, this.props.itemIndex)} className={`marginTop ${this.props.data.highlight ? 'active' : ''}`}>
                <div className="moban-left">

                    <div style={{ display: this.props.data.highlight ? 'block' : 'none' }}>
                        <span>提示：{this.props.data.module_hint}</span>
                    </div>
                    <TextareaAutosize id={"body_" + this.props.data.module_id} defaultValue={this.state.textareaValue} value={this.state.textareaValue} onChange={this.handleValueChange}/>
                    
                </div>

                <div className="moban-right">
                    <img src= { video_play } onClick={this.handleItemClick.bind(this, this.props.data.video_url)} style={{display: this.props.data.highlight && this.props.data.video_url.length > 0 ? 'block': 'none'}}/>
                    <img src= { randomfile } onClick={this.handleRandomClick.bind(this, this.props.data)} style={{display: this.props.data.highlight && this.props.data.modules.length > 0 ? 'block': 'none'}}/>
                    <img src= { checkfile } style={{ display:  'none' }} onClick={ this.detectionClick }/>
                </div>
            </div>
        );
    }
}


MobanItem.propTypes = {
    playVideo: PropTypes.func,
  };

export default MobanItem
